<template>
	<div class="long_row profile_builder">
		<div class="row">
			<div class="col-6 txt_container">
				<span class="ace_sec">{{profileText}}</span>
			</div>
			<div class="col-6 btn_container">
				<b-button class="lg ace_sec" @click="showProfileQuestionModal" title="">
					<span class="ic"></span>
					<span class="txt">Build Your Profile</span>
				</b-button>
			</div>
		</div>
    <learner-profile-question ref="profileBuilderQuestion"></learner-profile-question>
	</div>
</template>

<script>
  import { mapActions } from 'vuex'
  import LearnerProfileQuestion from './LearnerProfileQuestion'

	export default {
		name: 'learner-profile-builder',
    components: {
      LearnerProfileQuestion
    },
		data: () => {
			return {
        profileText: 'Tell us about yourself so that $TITLE$ can support your aspirations.'
			}
		},
    mounted () {
			this.loadInstitutionMetaInfo().then(resp => {
				this.profileText = this.profileText.replace('$TITLE$', resp.title)
			})
		},
    methods: {
			...mapActions([
	      'loadInstitutionMetaInfo'
	    ]),
      showProfileQuestionModal () {
        this.$refs.profileBuilderQuestion.showAddProgCarIntModal()
      }
		}
	}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/app/dashboard/components/LearnerProfileBuilder.vue